export const RoundedCheckboxChecked = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1"
      y="1"
      width="18"
      height="18"
      rx="4"
      ry="4"
      stroke="rgba(157, 78, 221, 1)"
      strokeWidth="1.5"
      fill="rgba(157, 78, 221, 1)"
    />
    <path
      d="M6 10L8.5 12.5L14 7"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
